import { Moment } from 'moment';
import { IndexedTimesheet } from '../../../../models/TimeAndAttendance';

export const createInitialAttendanceState = (date: Date | null) => {
  return {
    startDate: date ?? new Date(),
    endDate: date ?? new Date(),
    id: '',
    submitted: false,
    workEvent: {
      startWorkHour: '00:00:00',
      endWorkHour: '00:00:00',
      startBreakHour: '00:00:00',
      endBreakHour: '00:00:00',
    },
    files: [],
  };
};

export const formatSelectedMonthYear = (date: Moment, locale: string) => {
  const formattedDate = date.locale(locale).format('MMMM YYYY');

  return formattedDate.at(0)?.toUpperCase() + formattedDate.slice(1);
};

export const isWeekend = (day: number, offset: number) => {
  if (day < 0) {
    ++day;
  }
  return (day + offset) % 7 === 6 || (day + offset) % 7 === 0;
};

export const getEnumKeyByValue = (
  enumToCheck: Record<string, string | number>,
  value: string,
) => {
  const indexOf = Object.values(enumToCheck).indexOf(value);
  const key = Object.keys(enumToCheck)[indexOf];
  return key.toLowerCase();
};

export const checkNextDayBound = (
  currentDay: IndexedTimesheet,
  nextDay: IndexedTimesheet,
) => {
  return nextDay?.id !== currentDay?.id || !nextDay.isBounded
    ? currentDay.presenceType?.presenceTypeDescription?.toLowerCase()
    : 'event-bond-start';
};

export const checkDefaultDayBound = (
  currentDay: IndexedTimesheet,
  nextDay: IndexedTimesheet,
  prevDay: IndexedTimesheet,
) => {
  return nextDay?.id !== currentDay?.id || !nextDay.isBounded
    ? checkPrevDayBound(currentDay, prevDay)
    : 'event-bond';
};

export const checkPrevDayBound = (
  currentDay: IndexedTimesheet,
  prevDay: IndexedTimesheet,
) => {
  return prevDay?.id !== currentDay?.id || !prevDay.isBounded
    ? currentDay.presenceType?.presenceTypeDescription?.toLowerCase()
    : 'event-bond-end';
};

export const checkBoundedDayType = (
  prevDay: any,
  currentDay: any,
  nextDay: any,
) => {
  return prevDay?.id !== currentDay?.id || !prevDay.isBounded
    ? checkNextDayBound(currentDay, nextDay)
    : checkDefaultDayBound(currentDay, nextDay, prevDay);
};

export const formatWeekToStandard = (weekDays: string[]): string[] => [
  ...weekDays.slice(1),
  weekDays[0],
];
